// src/components/GrowthSection.jsx
import React from 'react';
import './GrowthSection.css';
import growthImageWebp from '../../images/growth-people-orange.webp';

export default function GrowthSection() {
  return (
    <section className="growth-section py-5">
      <div className="container">
        <div className="row gy-5 align-items-center flex-column-reverse flex-lg-row">
          {/* Tekstkolom */}
          <div className="col-12 col-lg-6">
            <h2 className="growth-title mb-4">
              Wil jij online<br />
              <span className="text-orange">beter gevonden worden?</span>
            </h2>

            <div className="text-card mb-4">
              <p>
                Bij <strong>OnlineGrowthClub.nl</strong> draait alles om online zichtbaarheid.
                Of je nu een nieuwe website nodig hebt, beter gevonden wilt worden via
                Google of zichtbaar wilt zijn op social media — wij zorgen dat jouw bedrijf
                online écht opvalt.
              </p>
              <p className="mb-0">
                Wij combineren SEO, conversiegerichte websites en slimme advertenties (SEA)
                om bezoekers om te zetten in klanten.
              </p>
            </div>

            <a href="/contact" className="btn btn-orange btn-lg shadow-sm">
              Ontvang gratis groeiscan
            </a>
          </div>

          {/* Afbeelding (WebP + loading optimalisatie) */}
          <div className="col-12 col-lg-6">
            <div className="image-wrapper mx-auto">
              <img
                src={growthImageWebp}
                alt="Professionals die samenwerken en vertrouwen uitstralen"
                className="img-fluid"
                loading="lazy"
                decoding="async"
                width="600"
                height="auto"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
